(function () {
function initHero(root) {
  if (!root || root.__r44vh) return; root.__r44vh = true;

  // "Shop all parts" button → scroll to the product grid
  var sc = root.querySelector('[data-r44vh-scroll]');
  if (sc) sc.addEventListener('click', function (e) {
    var t = document.getElementById('r44-products') || document.querySelector('[id$="__main"]');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  var card = root.querySelector('[data-r44vg]');
  if (!card) return;
  var designMode = card.dataset.designMode === '1';
  var DELIM = 'easysearch-preselect-delimiter';
  var DONE_KEY = 'r44-garage-signed-up';
  var paneMatch = card.querySelector('[data-r44vg-match]');
  var paneOther = card.querySelector('[data-r44vg-other]');
  var panePick = card.querySelector('[data-r44vg-pick]');
  var slot = card.querySelector('.r44vg-es');
  // Names are compared as slugs, so "F20 M135i Hatchback (5 Door)" matches "f20-m135i-hatchback--5-door-".
  function norm(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  var models = (card.dataset.make ? card.dataset.models.split('|') : []).map(norm).filter(Boolean);
  var make = norm(card.dataset.make);

  function getLS(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  // ---------- Garage (EasySearch localStorage) ----------
  function parseCar(str) {
    var p = String(str || '').split(DELIM);
    if (!p[1] || !p[2]) return null;
    return { year: (p[0] || '').trim(), make: p[1].trim(), model: p[2].trim() };
  }
  function readGarage() {
    var list = [];
    try { var raw = JSON.parse(getLS('easysearch-garage-items') || 'null'); list = (raw && raw.value) ? raw.value : (Array.isArray(raw) ? raw : []); } catch (e) {}
    return list.map(parseCar).filter(Boolean);
  }
  // "Your car": the site-wide primary garage car (snippets/r44-garage-primary.liquid), else the last car added
  function currentCar(cars) {
    if (window.R44Garage && typeof window.R44Garage.primary === 'function') {
      var p = window.R44Garage.primary();
      if (p) return { year: p.year, make: p.make, model: p.model };
    }
    try { var pre = JSON.parse(getLS('easysearch-preselect') || 'null'); var c = parseCar(pre && pre.value); if (c) return c; } catch (e) {}
    return cars[cars.length - 1] || null;
  }
  function fits(c) { return c && models.length && norm(c.make) === make && models.indexOf(norm(c.model)) !== -1; }
  function label(c) { return [c.year, c.make, c.model].join(' '); }
  function shortName(c) { return (c.make === 'BMW' ? '' : c.make + ' ') + c.model; }
  // EasySearch's own parts page for a car: /collections/all/<tag>. The R44 vehicle redirect forwards it to the model page when one exists.
  function carUrl(c) {
    var t = window.easysearch && window.easysearch.tree;
    var u = t && t[c.year + ',' + c.make + ',' + c.model + ','];
    u = Array.isArray(u) ? u[0] : u;
    return u ? String(u) : null;
  }
  function carTag(c) { var u = carUrl(c); return u ? u.split('?')[0].split('/').pop() : null; }

  function showPane(name) {
    card.setAttribute('data-pane', name);
    paneMatch.hidden = name !== 'match';
    paneOther.hidden = name !== 'other';
    panePick.hidden = name !== 'pick';
  }

  var forcePick = false;
  function render() {
    if (forcePick) return showPane('pick');
    var cars = readGarage();
    if (!cars.length) return showPane('pick');
    var fit = null;
    for (var i = cars.length - 1; i >= 0; i--) { if (fits(cars[i])) { fit = cars[i]; break; } }
    if (fit) {
      paneMatch.querySelector('[data-r44vg-car]').textContent = label(fit);
      var tg = paneMatch.querySelector('[data-r44vg-toggle]');
      if (tg) {
        if (card.dataset.filtered) { tg.href = card.dataset.base; }
        else {
          var tag = carTag(fit);
          if (tag) { tg.href = card.dataset.base + '/' + tag; tg.hidden = false; } else { tg.hidden = true; }
        }
      }
      return showPane('match');
    }
    var car = currentCar(cars);
    paneOther.querySelector('[data-r44vg-car]').textContent = (card.dataset.otherPrefix || '') + label(car);
    var go = paneOther.querySelector('[data-r44vg-go]');
    var url = carUrl(car);
    go.textContent = (card.dataset.otherButton || '[car]').replace('[car]', shortName(car));
    go.hidden = !url;
    if (url) go.href = url;
    showPane('other');
  }

  Array.prototype.forEach.call(card.querySelectorAll('[data-r44vg-change]'), function (b) {
    b.addEventListener('click', function () { forcePick = true; card.classList.add('is-open'); render(); });
  });
  var opener = card.querySelector('[data-r44vg-open]');
  if (opener) opener.addEventListener('click', function () { card.classList.add('is-open'); opener.setAttribute('aria-expanded', 'true'); });

  render();
  // EasySearch builds its tree after load; re-render once it's there, and whenever the garage changes
  var lastGarage = getLS('easysearch-garage-items');
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    var g = getLS('easysearch-garage-items');
    if (g !== lastGarage) { lastGarage = g; forcePick = false; render(); }
    else if (tries < 20 && window.easysearch && window.easysearch.tree) { render(); }
  }, 700);

  // ---------- Save car + email signup (same as homepage My Garage) ----------
  var box = card.querySelector('[data-r44vg-signup]');
  if (!box) return;
  var titleEl = box.querySelector('[data-r44vg-signup-title]');
  var form = box.querySelector('form'), input = form.querySelector('input'), btn = form.querySelector('button');
  var msg = box.querySelector('[data-r44vg-signup-msg]');
  var skip = box.querySelector('[data-r44vg-signup-skip]');
  var lastKey = '';

  function show(text, type) { msg.hidden = false; msg.textContent = text; msg.className = 'r44vg-signup__msg' + (type ? ' is-' + type : ''); }
  function selectedCar() {
    var sels = slot ? slot.querySelectorAll('.easysearch-field-select-holder select') : [];
    var vals = [];
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (!sel.value) return null;
      vals.push((sel.options[sel.selectedIndex] || {}).text || sel.value);
    }
    if (vals.length < 3) return null;
    return { year: vals[0].trim(), make: vals[1].trim(), model: vals[vals.length - 1].trim() };
  }
  function esGarageButton() { return slot && slot.querySelector('.easysearch-btn-garage'); }
  function hideNativeGarageButton() {
    var b = esGarageButton();
    if (b) { var h = b.closest('.easysearch-btn-holder'); if (h) h.classList.add('r44vg-es-hide'); }
  }
  function refresh() {
    hideNativeGarageButton();
    var car = selectedCar();
    var key = car ? car.year + car.make + car.model : '';
    if (key === lastKey) return;
    lastKey = key;
    if (car) {
      titleEl.innerHTML = esc(box.dataset.titleCar).replace('[car]', '<span>' + esc(shortName(car)) + '</span>');
      box.classList.add('is-hot');
    } else {
      titleEl.textContent = box.dataset.title;
      box.classList.remove('is-hot');
    }
  }

  var testMode = false;
  try {
    if (/[?&]r44_garage_test=1/.test(location.search)) sessionStorage.setItem('r44-garage-test', '1');
    if (/[?&]r44_garage_test=0/.test(location.search)) sessionStorage.removeItem('r44-garage-test');
    testMode = sessionStorage.getItem('r44-garage-test') === '1';
  } catch (e) {}

  var started = false;
  function start() {
    if (started) return; started = true;
    box.hidden = false;
    card.classList.add('r44vg--combined');
    refresh();
    setInterval(refresh, 700);
  }
  function stop() { box.hidden = true; card.classList.remove('r44vg--combined'); }

  if (!designMode && !testMode && (box.dataset.customer === '1' || getLS(DONE_KEY))) {
    stop();
  } else {
    start();
    if (!designMode && !testMode) {
      (function check(n) {
        var k = window.klaviyo;
        if (k && typeof k.isIdentified === 'function') {
          Promise.race([Promise.resolve(k.isIdentified()), new Promise(function (r) { setTimeout(function () { r(false); }, 4000); })])
            .then(function (known) { if (known === true && !form.hidden && !btn.disabled) stop(); }, function () {});
        } else if (n < 40) { setTimeout(function () { check(n + 1); }, 250); }
      })(0);
    }
  }

  function saveToGarage() { var b = esGarageButton(); if (b) { b.click(); return true; } return false; }
  function withTimeout(p, ms) { return Promise.race([Promise.resolve(p), new Promise(function (r) { setTimeout(r, ms); })]); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var car = selectedCar();
    if (!car) { show(box.dataset.needCar || 'Choose your Year, Make and Model first.', 'error'); return; }
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show('Please enter a valid email address.', 'error'); input.focus(); return; }
    var props = {
      'Signup Source': box.dataset.source,
      'Signup Page': location.pathname,
      'Primary Vehicle': [car.year, car.make, car.model].join(' '),
      'Primary Vehicle Year': car.year,
      'Primary Vehicle Make': car.make,
      'Primary Vehicle Model': car.model,
      'Primary Chassis': (car.model.split(' ')[0] || '').toUpperCase()
    };
    btn.disabled = true; show('Saving your ' + shortName(car) + '…');
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(box.dataset.key), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: box.dataset.source,
        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
      }, relationships: { list: { data: { type: 'list', id: box.dataset.list } } } } })
    }).then(function (r) {
      if (r.status !== 202 && !r.ok) {
        return r.text().then(function (t) { console.warn('[R44 garage signup] Klaviyo said:', r.status, t); throw new Error('status ' + r.status); });
      }
      setLS(DONE_KEY, '1');
      var id = (window.klaviyo && typeof window.klaviyo.identify === 'function') ? window.klaviyo.identify({ email: email }) : null;
      return withTimeout(id, 1500);
    }).then(function () {
      form.hidden = true;
      show((box.dataset.success || 'Saved!').replace('[car]', shortName(car)), 'success');
      box.classList.remove('is-hot');
      // Hand over to EasySearch: saves the car to My Garage and opens its parts (model) page
      setTimeout(function () { if (!saveToGarage()) { card.classList.remove('r44vg--combined'); } }, 700);
    }).catch(function () {
      btn.disabled = false;
      show('Sorry, something went wrong. Please try again.', 'error');
    });
  });

  if (skip) skip.addEventListener('click', function () {
    if (!selectedCar()) { show(box.dataset.needCar || 'Choose your Year, Make and Model first.', 'error'); return; }
    saveToGarage();
  });
}
function initAll() { Array.prototype.forEach.call(document.querySelectorAll('.r44vh'), function (el) { initHero(el.closest('.shopify-section') || el.parentNode); }); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
document.addEventListener('shopify:section:load', initAll);
})();
